// @systeme: interface
// Dans Moi : mon compte. Télécharger mes documents, et partir : la suppression se
// demande en deux gestes, prend effet trente jours plus tard, et s'annule d'un geste.
// Jamais de culpabilisation, jamais de « es-tu sûre ? » en boucle.
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { api } from '../lib/api';
import { formaterDateComplete, jourDe } from '../lib/dates';
import { useSession, useSessionConnectee } from '../session/SessionContext';
import { useMessages } from './Messages';

export function SectionCompte() {
  const session = useSessionConnectee();
  const { mettreAJour, deconnecter } = useSession();
  const { dire, direErreur } = useMessages();
  const [confirmer, setConfirmer] = useState(false);
  const prevueLe = session.utilisateur.suppressionPrevueLe;

  async function demander() {
    try {
      mettreAJour(await api.moi.demanderSuppression());
      setConfirmer(false);
      dire('C’est noté. Tu as trente jours pour changer d’avis.');
    } catch (e) {
      direErreur(e);
    }
  }

  async function deconnecterPartout() {
    try {
      await api.auth.deconnexionPartout();
      await deconnecter();
    } catch (e) {
      direErreur(e);
    }
  }

  async function annuler() {
    try {
      mettreAJour(await api.moi.annulerSuppression());
      dire('Contente que tu restes. Rien n’a bougé.');
    } catch (e) {
      direErreur(e);
    }
  }

  return (
    <Box>
      <Typography variant="h2" component="h2" gutterBottom>
        Mon compte
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 1.5 }}>
        Tes photos et documents sont à toi : tu peux les récupérer d’un coup, dans une archive.
      </Typography>
      <Stack spacing={1.5} alignItems="flex-start">
        <Button variant="outlined" component="a" href={api.moi.urlExport()} download>
          Télécharger mes documents
        </Button>
        <Button color="inherit" onClick={() => void deconnecterPartout()}>
          Me déconnecter de tous mes appareils
        </Button>
        {prevueLe ? (
          <>
            <Typography>
              Ton compte sera supprimé le {formaterDateComplete(jourDe(prevueLe))}. D’ici là, tu
              peux encore te connecter et changer d’avis.
            </Typography>
            <Button variant="contained" onClick={() => void annuler()}>
              Finalement, je reste
            </Button>
          </>
        ) : confirmer ? (
          <>
            <Typography>
              Ton compte, ton foyer si tu en es la seule responsable, et tout ce qu’ils contiennent
              seront supprimés dans trente jours. L’abonnement s’arrête tout de suite. Tu pourras
              changer d’avis jusque-là.
            </Typography>
            <Stack direction="row" spacing={1}>
              <Button color="error" variant="contained" onClick={() => void demander()}>
                Oui, supprimer mon compte
              </Button>
              <Button color="inherit" onClick={() => setConfirmer(false)}>
                Finalement non
              </Button>
            </Stack>
          </>
        ) : (
          <Button color="inherit" onClick={() => setConfirmer(true)}>
            Supprimer mon compte
          </Button>
        )}
      </Stack>
    </Box>
  );
}
